module.exports = __webpack_public_path__ + "img/step1img.fee5d3db.png";